import { render, staticRenderFns } from "./PopupAccidentReportList.vue?vue&type=template&id=2878fddc&scoped=true"
import script from "./PopupAccidentReportList.vue?vue&type=script&lang=js"
export * from "./PopupAccidentReportList.vue?vue&type=script&lang=js"
import style0 from "./PopupAccidentReportList.vue?vue&type=style&index=0&id=2878fddc&prod&lang=scss"
import style1 from "./PopupAccidentReportList.vue?vue&type=style&index=1&id=2878fddc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2878fddc",
  null
  
)

export default component.exports